var _circle, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorSwapDisabled = function SvgColorSwapDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9,
    r: 6,
    fill: "#748499"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m8.298 5.118 1.18-1.51a.92.92 0 0 0 .112-.951L8.698.717a.92.92 0 0 0-1.67.768l.657 1.431-.836 1.07a.92.92 0 0 0 1.45 1.133",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3 6.383C3.688 3.257 7.318 4.02 7.318 4.02a.92.92 0 0 0 .347-1.806s-5.415-.98-6.462 3.774A.92.92 0 0 0 3 6.383",
    clipRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 14,
    r: 6,
    fill: "#ACB5C2"
  })));
};
export { SvgColorSwapDisabled as ReactComponent };
export default __webpack_public_path__ + "fonts/color-swap-disabled-8c1c43d7a58294225ef7c6e8dd53e504.svg";